import { type NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const redirectToHomeIfNoInsightsAccess: NavigationGuard = async (to, from, next) => {
  const authStore = useAuthStore();

  if (authStore.appAccess.nav.insights) {
    return next();
  } else {
    return next({ name: 'home' });
  }
};
